import axios from 'axios';

const API_URL = '/api/medical-conditions';

export const getMedicalConditions = async (userId) => {
    try {
        const response = await axios.get(`${API_URL}/${userId}`);
        return response.data;
    } catch (error) {
        console.error("Error fetching medical conditions:", error);
        throw error;
    }
};

export const createMedicalCondition = async (conditionData) => {
    try {
        const response = await axios.post(API_URL, conditionData);
        return response.data;
    } catch (error) {
        console.error("Error creating medical condition:", error);
        throw error;
    }
};

export const updateMedicalCondition = async (id, conditionData) => {
    try {
        const response = await axios.put(`${API_URL}/${id}`, conditionData);
        return response.data;
    } catch (error) {
        console.error("Error updating medical condition:", error);
        throw error;
    }
};

export const deleteMedicalCondition = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        console.error("Error deleting medical condition:", error);
        throw error;
    }
};

